import React from 'react';
import cn from 'classnames';
import styles from '../CalendarGrid.module.scss';

const Cells = ({
  rowCount,
  className,
  zIndex = 2,
  style = {},
  onClick,
  ...props
}) => {
  if (!rowCount) {
    return (
      <div
        {...props}
        className={cn(styles.borderBottom, className)}
        style={{
          ...style,
          zIndex: zIndex,
        }}
        onClick={onClick}
      />
    );
  }

  return Array.from(Array(rowCount)).map((_, index) => {
    const currentStyle = typeof style === 'function' ? style(index) : style;

    return (
      <div
        {...props}
        key={index}
        className={cn(styles.borderBottom, className)}
        style={{
          ...currentStyle,
          zIndex: zIndex,
        }}
        onClick={
          typeof onClick === 'function' ? (e) => onClick(e, index) : undefined
        }
      />
    );
  });
};

export default Cells;
